module.exports = __webpack_public_path__ + "static/img/function-box-img4.583c449.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedProcess/function-box-img4.png
// module id = 029Q
// module chunks = 0